import { Link } from "@mui/material";
import { Link as RouterLink } from "react-router";
import type { LookupObjectReference } from "../../../../api/types/objectTypes";
import useClientContext from "../../../../context/useClientContext";
import { pageRoutes } from "../../../../routes";

export const NameCell = ({ row }: { row: LookupObjectReference }) => {
  const { clientCode } = useClientContext();

  return (
    <Link
      component={RouterLink}
      to={`/${clientCode}/${pageRoutes.portfolio}/${pageRoutes.portfolioCompanies}/${row.objectId}?tab=portfoliocontacts`}
      target="_blank"
      rel="noopener noreferrer"
      color="inherit"
      underline="none"
      sx={(t) => ({
        "&:hover": {
          textDecoration: "underline",
          color: t.palette.primary.main,
        },
      })}
    >
      {row.primaryFieldValue}
    </Link>
  );
};
